import React from 'react';
import SectionTitle from '../SectionTitle';
import CardPreviewLogo from '../CardPreviewLogo';

const Logo = ({ images, deleteLogo }) => (
	<div>
		<div className="row">
			<div className="col-12">
				<SectionTitle titleSize="16px" titleHeight="30px" title="Logos cadastrados" />
			</div>
		</div>
		<div className="row">
			<div className="col-12">
				<div className="row">
					{images.map(logo => (
						<div className="col-lg-6 col-sm-12 mb-2">
							<CardPreviewLogo
								logo={logo}
								deleteOption
								handleDelete={deleteLogo}
							/>
						</div>
                    ))}
				</div>
			</div>
		</div>
	</div>
);


export default Logo;
